import { accessRole } from '../../../../helpers/access_role'
import React, { Fragment, Component } from 'react'
import {
    Container,
    Row, Col,
    CardBody, Card, CardTitle, CardSubtitle,
    Button,
    Fieldset, Legend, Input, Label
} from "reactstrap"
import { ConfirmAlert } from '../../../../helpers/ui/alert'
import Select from '../../../../helpers/ui/CustomSelect'
import { AvForm, AvGroup, AvInput, AvCheckboxGroup, AvCheckbox } from "availity-reactstrap-validation"

import { Link, useHistory, Redirect } from "react-router-dom"
import Shimmer from 'react-shimmer-effect'

import apiResponse from '../../../../services/apiResponse'

import IndexBloc from '../Index/Blocs/IndexBloc'

class IndexView extends Component {

    timer
    indexBloc = new IndexBloc();

    constructor(props) {
        super(props)
        this.state = {
            dataForm: {},
        }
    }

    loadDetail = async () => {
        await this.indexBloc.fetchDetail({ uuid: this.props.uuid })
    }

    componentDidMount() {
        this.loadDetail()

        this.indexBloc.detailChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState({ detail: result.data.response })
                    break
                default:
                    break
            }
        })       

    }

    componentWillUnmount() {
        this.indexBloc.detailChannel?.unsubscribe()
    }

    render() {
        const { detail } = this.state
        return (
            <Fragment>
                <Container fluid>
                    <Card>
                        <CardBody>
                            <div className="float-end">
                                <Link to={`/master/jabatan_bkn.html`}>
                                    <Button outline color="primary"><i className="uil uil-backward"></i> Kembali</Button>
                                </Link>
                            </div>
                            <CardTitle>Detail Jabatan Bkn</CardTitle>
                            <hr />

                            <Row className="mb-3">
                                <label
                                    htmlFor="rank_name"
                                    className="col-md-2 col-form-label"
                                >
                                Nama E-Formasi
                                </label>
                                <Col md="5">
                                    { detail ? 
                                        <Label className="col-form-label">
                                            {detail?.position_bkn_name}
                                        </Label>
                                        :
                                        <Shimmer>
                                            <div style={{ width: "480px", height: "16px", alignSelf: "center", borderRadius: "8px", 
                                                        marginTop: 'calc(0.47rem + 1px)', marginBottom: 'calc(0.47rem + 1px)', fontSize: 'inherit', lineHeight: '1.5' }} />
                                        </Shimmer>
                                    }
                                </Col>
                            </Row>
                        </CardBody>
                    </Card>

                </Container>
               
            </Fragment>
        )
    }

}

export default IndexView